
// -- copyright
// OpenProject is a project management system.
// Copyright (C) 2012-2015 the OpenProject Foundation (OPF)
//
// This program is free software; you can redistribute it and/or
// modify it under the terms of the GNU General Public License version 3.
//
// OpenProject is a fork of ChiliProject, which is a fork of Redmine. The copyright follows:
// Copyright (C) 2006-2013 Jean-Philippe Lang
// Copyright (C) 2010-2013 the ChiliProject Team
//
// This program is free software; you can redistribute it and/or
// modify it under the terms of the GNU General Public License
// as published by the Free Software Foundation; either version 2
// of the License, or (at your option) any later version.
//
// This program is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU General Public License for more details.
//
// You should have received a copy of the GNU General Public License
// along with this program; if not, write to the Free Software
// Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
//
// See doc/COPYRIGHT.rdoc for more details.
// ++

import {ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, Output, OnDestroy} from '@angular/core';
import {I18nService} from 'core-app/modules/common/i18n/i18n.service';
import {EditFormComponent} from "core-app/modules/fields/edit/edit-form/edit-form.component";
import {Photo_logService} from '../../photo_log/services/photo_log.service';
import {HookService} from 'core-app/modules/plugins/hook-service';
import {Subscription} from 'rxjs';

@Component({
  templateUrl: './wp-edit-actions-bar.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'wp-edit-actions-bar',
})
export class WorkPackageEditActionsBarComponent implements OnDestroy {
  @Output('onSave') public onSave = new EventEmitter<void>();
  @Output('onCancel') public onCancel = new EventEmitter<void>();
  public _saving:boolean = false;

  public text = {
    save: this.I18n.t('js.button_save'),
    cancel: this.I18n.t('js.button_cancel')
  };
  public hasid:any
  public id:any
  public prefix:string = '';
  public type_value:string = '';
  private globalVarSubscription:Subscription;

  constructor(private I18n:I18nService,
    public service: Photo_logService,
              private editForm:EditFormComponent,
              private cdRef:ChangeDetectorRef,
              private hook:HookService) {


  }
  ngOnInit():void {
     this.hook.globalVar.subscribe((data:any) => {
      if(data && data.length > 0) {
        this.prefix = data[0].prefix || '';
        this.type_value = data[0].type_value || '';
        if(this.type_value === '-') {
          this.type_value = '';
        }
        console.log('[wp-edit-actions-bar] 从数据中提取 - prefix:', this.prefix, 'type_value:', this.type_value);
      } else {
        this.prefix = '';
        this.type_value = '';
        console.log('[wp-edit-actions-bar] 数据为空，设置默认值');
      }
      this.cdRef.detectChanges();
    });

  }
  ngOnDestroy():void {
    if (this.globalVarSubscription) {
      this.globalVarSubscription.unsubscribe();
    }
  }

  // 判断按钮是否应该禁用
  get isSaveDisabled():boolean {
    // globalVar 已初始化后，检查 prefix 和 type_value
    return this.saving || !this.prefix || !this.type_value;
  }

  public set saving(active:boolean) {
    this._saving = active;
    this.cdRef.detectChanges();
  }

  public get saving() {
    return this._saving;
  }

  public save():void {
    //如果有localstorage的话，调用关联api
    // this.hasid = localStorage.getItem('imageid')
    // if(this.hasid)
    // this.id = this.hasid.toString()
    // //console.log(this.id,'keke')
    // this.service.relationTask({photo_log_id:this.id,work_package_id})
    if (this.saving) {
      return;
    }

    this.saving = true;
    this.editForm
      .save()
      .then(() => {
        this.saving = false;
        this.onSave.emit();
      })
      .catch(() => {
        this.saving = false;
      });
  }

  public cancel():void {
    this.editForm.stop();
    this.onCancel.emit();
  }
}
